import { GetUserByPersonalNumberResponse } from './types';
import { createSejfaRequest } from '../../api-definition';

export const getUserByPersonalNumber = (personalNumber: string) =>
  createSejfaRequest<GetUserByPersonalNumberResponse, void>({
    path: 'user',
    method: 'GET',
    pathParameters: [personalNumber]
  });
